import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, Control, TextValues } from './florida-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';
import { RequestService } from '../../../_services/request/request.service';

@Component({
  selector: 'app-florida',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    CommonModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './florida.component.html',
})
export class FloridaComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('florida', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('florida', null);
    }
  }

   constructor(private requestService: RequestService) {
      super();
    }

  override calculatePremium(c: Control) {
      if (
        c.baseRuleKey === 'UMLiabilityMinLimit_DropDown'
      ) {
        return {
          id: 1,
          name: this.requestService
            .getLiabilityLimitForState('florida')
            .split('.')[0],
        };
      } else {
        return {
          id: 1,
          name:
            this.requestService
              .getLiabilityLimitForState('florida')
              .split('.')[0] +
            '/' +
            this.requestService
              .getLiabilityLimitForState('florida')
              .split('.')[0],
        };
        
      }
    }
}
